var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudioVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27123",
    "data-name": "Group 27123",
    transform: "translate(-79 -588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "movie",
    d: "M6,15v3h8V11H6ZM4,13V11H2V9H4V7H2v6Zm0,2H2v1a2,2,0,0,0,2,2Zm14-2V7H16V9h2v2H16v2Zm0,2H16v3a2,2,0,0,0,2-2ZM14,7V2H6V9h8Zm4-2V4a2,2,0,0,0-2-2V5ZM4,5V2A2,2,0,0,0,2,4V5ZM4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(85 594)",
    fill: "#adadad",
    strokeWidth: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioVideo);
export default __webpack_public_path__ + "static/media/Audio_Video.a566ee0b.svg";
export { ForwardRef as ReactComponent };